module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_8019.2e8886c1.png";